import React from 'react';
import styled from 'styled-components';
import { faCheckCircle, faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const LoadingLineBox = styled.span.withConfig({
  displayName: "LoadingBar__LoadingLineBox",
  componentId: "sc-133zlv9-0"
})(["border-radius:4px;background-color:white;border:1px solid darkgray;padding:0.2em 3em;position:relative;white-space:nowrap;font-size:", ";span{position:relative;}"], props => props.fontScale ? props.fontScale * 100 + "%" : undefined);
const LoadingBarBackground = styled.div.withConfig({
  displayName: "LoadingBar__LoadingBarBackground",
  componentId: "sc-133zlv9-1"
})(["left:0;top:0;bottom:0;position:absolute;background-color:orange;"]);
export const LoadingBar = ({
  percentage100,
  fontScale,
  label,
  className
}) => {
  return /*#__PURE__*/React.createElement(LoadingLineBox, {
    fontScale: fontScale,
    className: className
  }, /*#__PURE__*/React.createElement(LoadingBarBackground, {
    style: {
      width: percentage100 + "%"
    }
  }), /*#__PURE__*/React.createElement("span", null, percentage100 < 100 ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCog,
    spin: true
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCheckCircle
  }), "\xA0", label, ": ", percentage100, "%"));
};
export const LoadingBarBlock = styled(LoadingBar).withConfig({
  displayName: "LoadingBar__LoadingBarBlock",
  componentId: "sc-133zlv9-2"
})(["display:block;text-align:center;"]);